import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import { getInstagramAdmin, addInstagramPost, deleteInstagramPost } from '../../services/adminService';
import { uploadToCloudinary } from '../../utils/uploadToCloudinary';

export default function AdminInstagram() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ Image: '', Title: '', Link: '' });
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = () => getInstagramAdmin().then(d => { setPosts(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try { const url = await uploadToCloudinary(file); setForm(f => ({ ...f, Image: url })); }
    catch { alert('Upload failed'); }
    finally { setUploading(false); }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!form.Image || !form.Title || !form.Link) return;
    setSaving(true);
    await addInstagramPost({ ...form, order: posts.length });
    setForm({ Image: '', Title: '', Link: '' });
    await load();
    setSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove?')) return;
    await deleteInstagramPost(id);
    setPosts(p => p.filter(x => x.id !== id));
  };

  return (
    <AdminLayout title="Instagram Highlights">
      <div className="admin-section">
        <div className="admin-section-header"><h2>Add New Post</h2></div>
        <div className="admin-section-body">
          <form className="admin-form" onSubmit={handleAdd} style={{ maxWidth: 500 }}>
            <div><label>Image</label>
              <label className="upload-box">
                <input type="file" accept="image/*" onChange={handleFile} />
                {uploading ? <p>Uploading…</p> : form.Image ? <img src={form.Image} alt="" style={{ maxHeight: 80 }} /> : <p>Click to upload</p>}
              </label>
            </div>
            <div><label>Title</label><input value={form.Title} onChange={e => setForm(f => ({ ...f, Title: e.target.value }))} placeholder="Post caption / title" required /></div>
            <div><label>Instagram Post URL</label><input type="url" value={form.Link} onChange={e => setForm(f => ({ ...f, Link: e.target.value }))} placeholder="https://instagram.com/p/..." required /></div>
            <div><button className="a-btn a-btn-primary" type="submit" disabled={saving || !form.Image}>{saving ? 'Saving…' : 'Add Post'}</button></div>
          </form>
        </div>
      </div>

      <div className="admin-section">
        <div className="admin-section-header"><h2>Current Posts ({posts.length})</h2></div>
        <div className="admin-section-body">
          {loading ? <div className="admin-spinner">Loading…</div> : (
            posts.length === 0 ? <div className="admin-empty">No posts yet</div> : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {posts.map(p => (
                  <div key={p.id} className="admin-list-item">
                    <img src={p.Image} alt={p.Title} className="img-preview" />
                    <div className="admin-list-item-content">
                      <strong>{p.Title}</strong>
                      <div style={{ fontSize: 12, color: 'var(--a-text-muted)' }}>{p.Link}</div>
                    </div>
                    <div className="admin-list-item-actions">
                      <button className="a-btn a-btn-sm a-btn-danger" onClick={() => handleDelete(p.id)}>Remove</button>
                    </div>
                  </div>
                ))}
              </div>
            )
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
